import {Queries} from '../../api/queries';
import {Select} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {SyntheticEvent, useCallback} from 'react';

interface InvoicePickerProps {
	id: string;
	selectedInvoiceId: string | null;
	onChange: (selectedInvoiceId: string) => void;
}

const InvoicePicker = ({id, selectedInvoiceId, onChange}: InvoicePickerProps) => {
	const {data: invoices} = useQuery(Queries.invoices());

	const onInvoiceSelected = useCallback(
		(event: SyntheticEvent<HTMLSelectElement>) => {
			const {value} = event.currentTarget;

			if (value) {
				onChange(value);
			}
		},
		[onChange],
	);

	return (
		<Select id={id} name='invoiceId' value={selectedInvoiceId ?? ''} onChange={onInvoiceSelected}>
			{selectedInvoiceId === null && <option value=''>Select an Invoice</option>}
			{invoices?.map((invoice) => (
				<option key={invoice.id} value={invoice.id.toString()}>
					{invoice.publicId.toString().padStart(4, '0')} - {invoice.description}
				</option>
			))}
		</Select>
	);
};

export default InvoicePicker;
